import React from 'react';

const Graph_Intro = () => {
    return (
        <div>Graph_Intro Component</div>
    );
}

export default Graph_Intro;
